import { ExpenseStatusEnum, ExpenseTagColorEnum } from "@finway-group/shared/lib/models"
import { HIGHLIGHT_RED, GREEN, HIGHLIGHT_BLUE, ORANGE, PURPLE } from "@finway-group/shared/lib/consts"

export const API_URL = process.env.REACT_APP_API_URL

export const FINWAY_ADMIN_EMAIL = process.env.REACT_APP_FINWAY_ADMIN_EMAIL

export const HELP_CENTER_LINK = "http://help.finway.de/"

export const IMPRINT_LINK = "https://finway.de/impressum"

export const TERMS_OF_SERVICES_LINK = "https://finway.de/karten-agb/"

export const PRIVACY_POLICY_LINK = "https://finway.de/datenschutzerklaerung"

export const PAYNETICS_TERMS_OF_AGREEMENT = "https://finway.de/wp-content/uploads/pdf/paynetics-termsofagreement.pdf"

export const WEAVR_TERMS_OF_AGREEMENT = "https://finway.de/wp-content/uploads/pdf/weavr-termsofagreement.pdf"

export const SOURCE_OF_FUNDS_DECLARATION = "https://finway.de/wp-content/uploads/downloads/source-of-funds-declaration.pdf"

export const DEFAULT_IMG_PATH = encodeURIComponent("imgs/default.svg")

export const LOGO_API = "https://logo.clearbit.com"

export const WEBAPP_VERSION = require("../../../package.json").version

export const INTERCOM_APP_ID: string | undefined = process.env.REACT_APP_INTERCOM_APP_ID

export const INTERCOM_TEST_APP_ID: string | undefined = process.env.REACT_APP_INTERCOM_TEST_APP_ID

export const USERPILOT_APP_ID: string | undefined = process.env.REACT_APP_USERPILOT_APP_ID

export const USERPILOT_TEST_APP_ID: string | undefined = process.env.REACT_APP_USERPILOT_TEST_APP_ID

export const WEAVR_UX_SCRIPT_URL = process.env.REACT_WEAVR_UX_SCRIPT_URL

export const WEAVR_UX_KEY: string | undefined = process.env.REACT_APP_WEAVR_UX_KEY

export const MIXPANEL_TOKEN: string = process.env.REACT_APP_MIXPANEL_TOKEN ? process.env.REACT_APP_MIXPANEL_TOKEN : `Some token`

export const BUGSNAG_API_KEY: string = process.env.REACT_APP_BUGSNAG_API_KEY ? process.env.REACT_APP_BUGSNAG_API_KEY : `Some token`

export const STRIPE_API_KEY: string = process.env.REACT_APP_STRIPE_API_KEY ?? ""

export const COMMIT: string | undefined = process.env.COMMIT

export const isDemo = process.env.REACT_APP_DEMO === "true"

export const isLocal = process.env.DEPLOY_ENVIRONMENT === "localhost"

export const ALLOWED_UPLOAD_FILE_SIZE_IN_MB = 10

export const WARNING_ORANGE = "#ffc069"

export const MAPBOX_ACCESS_TOKEN = process.env.MAPBOX_ACCESS_TOKEN

// order is important! index values are used for this array
export const expenseStati = [
    "label:purchase_pending",
    "label:documents_needed",
    "label:invoice_pending",
    "label:in_review",
    "label:declined",
    "label:in_payment",
    "label:in_export",
    "label:processed",
]

export const ExpenseStati = Object.values(ExpenseStatusEnum)

export const US_DATE_DISPLAY_FORMAT = "Do MMM, YYYY"
export const DE_DATE_DISPLAY_FORMAT = "DD. MMM, YYYY"
export const DE_DATE_FORMAT = "DD.MM.YYYY"
export const US_DATE_FORMAT = "MM/DD/YYYY"

export enum NumberFormat {
    US,
    DE,
}

export const barProps = {
    margin: { top: 20, right: 0, bottom: 40, left: 70 },
    innerPadding: 1,
    labelTextColor: "#ffffff",
    labelSkipWidth: 32,
    labelSkipHeight: 20,
    enableGridX: false,
    enableGridY: false,
    theme: { axis: { ticks: { line: { stroke: "#231c5b" }, text: { fill: "#231c5b" } } } },
    animate: true,
    motionStiffness: 50,
    motionDamping: 15,
}

export const pieProps = {
    margin: { top: 30, right: 30, left: 30, bottom: 30 },
    innerRadius: 0.5,
    padAngle: 1.5,
    cornerRadius: 0,
    enableRadialLabels: false,
    radialLabelsSkipAngle: 10,
    radialLabelsTextXOffset: 6,
    radialLabelsTextColor: "#231c5b",
    radialLabelsLinkStrokeWidth: 1,
    radialLabelsLinkOffset: 1,
    radialLabelsLinkDiagonalLength: 10,
    radialLabelsLinkHorizontalLength: 5,
    sliceLabelsTextColor: "#ffffff",
    sliceLabelsSkipAngle: 20,
    animate: true,
    motionStiffness: 50,
    motionDamping: 15,
}

export const defaultCountry = "DE"

export const NO_TAX_RATE = "NO_TAX_RATE"
export const NO_PARENT_COST_CENTER = "NO_PARENT_COST_CENTER"

// TODO: extract to shared
export const ALLOWED_DATEV_BU_CODES = [
    1,
    6,
    7,
    8,
    9,
    16,
    17,
    18,
    19,
    40,
    49,
    ...[...Array(10).keys()].map((i) => i + 50), // 50-59
    91,
    92,
    94,
    95,
    97,
    98,
    99,
    400,
    401,
    402,
    490,
    506,
    507,
    511,
    512,
    516,
    517,
    521,
    522,
    525,
    526,
    527,
    531,
    532,
    536,
    537,
    541,
    542,
    546,
    547,
    551,
    552,
    556,
    557,
    561,
    562,
    566,
    567,
    701,
    702,
    ...[...Array(100).keys()].map((i) => i + 900), // 900-999
    6501,
    6502,
    6506,
    6507,
    6511,
    6512,
    6516,
    6517,
    6521,
    6522,
    6526,
    6527,
    6531,
    6532,
    6536,
    6537,
    6541,
    6542,
    6546,
    6547,
    6551,
    6552,
    6556,
    6557,
    6561,
    6562,
    6566,
    6567,
    6701,
    6702,
    9401,
    9402,
    9501,
    9506,
    9701,
    9510,
]

export const archiveAfterXDaysDefaults = [1, 30, 60, 90, 180, 365]

export const EXPENSE_TAG_ICON_COLORS = {
    [ExpenseTagColorEnum.RED]: HIGHLIGHT_RED,
    [ExpenseTagColorEnum.GREEN]: GREEN,
    [ExpenseTagColorEnum.BLUE]: HIGHLIGHT_BLUE,
    [ExpenseTagColorEnum.YELLOW]: ORANGE,
    [ExpenseTagColorEnum.PURPLE]: PURPLE,
}
// TODO: extract into shared
export enum ErrorCodeEnum {
    NO_EMAIL_ALIAS = "NO_EMAIL_ALIAS",
}

export const DEFAULT_PER_DIEM_DESTINATION = "Deutschland"

export const DATA_UPLOAD_SPREADSHEET_TEMPLATE_NAME = process.env.TEMPLATE_DATA_UPLOAD_SPREADSHEET || "finway_data_import.xlsx"
export const DATA_UPLOAD_SPREADSHEET_TEMPLATE_DISPLAY_NAME = "finway_data_import.xlsx"

export const REIMBURSABLE_DURATION_THRESHOLD_MINUTE = 8 * 60

// TODO FA-161: Refactor and let these values be provided by the backend and store them in redux
export const PER_DIEM_BREAKFAST_RATE = 0.2
export const PER_DIEM_LUNCH_RATE = 0.4
export const PER_DIEM_DINNER_RATE = 0.4
